import { version } from '../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://dev-ng.sharelock.pro',
  version: version,
};
